export const ROUTER_PAGE_403 = '/error/403';

export const uriConsts = {
  admin: '/admin',
  auth: {
    login: '/auth/login', // trang đăng nhập pos | meta
    callback: '/auth/callback', // api handshake sau khi nhận code/token
  },
  login: '/login', // trang chọn page
  logout: '/auth/logout',
  register: '/auth/register',
  profile: '/auth/profile',
  customer: {
    CUSTOMER_INDEX: '/customer',
    LIST: '/business/customer/list',
  },
  user: {
    loadPermissions: '/user/load/permissions',
  },
  product: {
    itemIndex: '/product/item/index',
  },
  report: {
    DASHBOARD_INDEX: '/report/dashboard',
    PAGE_INDEX: '/report/page/index',
    DASHBOARD_INTERACTIVE: '/report/interactive',
    DASHBOARD_STAFF: '/report/staff',
    DASHBOARD_ACTIVITY: '/report/activity',
    DASHBOARD_TAG: '/report/tag',
    DASHBOARD_POST: '/report/post',
    DASHBOARD_FBAD: '/report/fbad',
    DASHBOARD_METACAPI: '/report/facebook/metacapi',
    DASHBOARD_LIVESHOPPING: '/report/liveshopping',
    DASHBOARD_LIVESTREAMS: '/report/livestreams',
  },
  chat: {
    CONVERSATION_INDEX: '/conversation',
  },
  feature: {
    INDEX: '/feature',
    // chatbot script list
    CHATBOT_LIST: '/feature/chatbot/list',
    // chatbot gen AI
    CHATBOT_GENAI: '/chatbot/genai/account',
    // chatbot automation calender
    CHATBOT_AUTOMATIONCALENDER: '/feature/chatbot/chase/list',
    // chatbot automation inbox
    CHATBOT_AUTOMATIONINBOX: '/feature/chatbot/automationInbox',
    // chatbot audience
    CHATBOT_AUDIENCE: '/meta/audience/index',
    // chatbot marketing
    CHATBOT_MARKETING: '/chatbot/marketing/index',
    // chatbot utility message
    CHATBOT_UTILITYMESSAGE: '/chatbot/utilitymessage',
    // chatbot ecom customer care
    CHATBOT_ECOMCUSTOMERCARE: '/chatbot/ecomcustomer',
  },
  live: {
    //shoppingfb
    LIVE_CHAT_SHOPPING_FB: '/live/shoppingfb',
    // shopping
    LIVE_CHAT_SHOPPING_LIST: '/live/shopping/list',
    LIVE_CHAT_SHOPPING_ADD: '/live/shopping/add',
    LIVE_CHAT_SHOPPING_EDIT: '/live/shopping/edit',
    // livestream
    LIVE_CHAT_LIVESTREAM: '/live/livestream',
    // setting
    LIVE_CHAT_SETTING: '/live/setting',
    // print comments
    LIVE_PRINT_COMMENTS: '/live/printcomments',
    // check live ads
    LIVE_VIDEO_ADS: '/live/checkliveads',
  },
  chatbot: {
    // script
    CHATBOT_SCRIPT: '/chatbot/script',
    // keyword
    CHATBOT_KEYWORD: '/chatbot/keyword',
    // comment
    CHATBOT_COMMENT: '/chatbot/comment',
    // menu
    CHATBOT_MENU: '/chatbot/menu',
    // marketing
    CHATBOT_MARKETING_INDEX: '/chatbot/marketing',
    CHATBOT_MARKETING_CAMPAIGN: '/chatbot/marketing/campaign',
    CHATBOT_MARKETING_CAMPAIGN_USER: '/chatbot/marketing/campaignUser',
    CHATBOT_MARKETING_LOGS: '/chatbot/marketing/logs',
    // report
    CHATBOT_REPORT_INDEX: '/chatbot/report',
    CHATBOT_REPORT_MESSAGE: '/chatbot/report/message',
    CHATBOT_REPORT_FEEDBACK: '/chatbot/report/feedback',
    CHATBOT_REPORT_CAMPAIGN_USER: '/chatbot/report/campaignUser',
    // setting
    CHATBOT_SETTING_INDEX: '/chatbot/setting',
    CHATBOT_SETTING_CONVERSATION: '/chatbot/setting/conversation',
    CHATBOT_SETTING_SHARE: '/chatbot/setting/share',
  },
  order: {
    ORDER_INDEX: '/order',
    ORDER_DRAFT: '/order/draft',
  },
  sys: {
    SYS_INDEX: '/sys',
    SYS_PAGES: '/sys/pages',
    SYS_USERS: '/sys/users',
    SYS_PAYMENT: '/sys/payment',
    SYS_REPORT_USER: '/sys/report-user',
    SYS_REPORT_PAGE_CONVERSATION: '/sys/report-page-conversation',
    SYS_REPORT_FBEVENT: '/sys/report-fbevent',
    SYS_BLOGS: '/sys/blogs',
    SYS_AUTHOR: '/sys/author',
    SYS_MOBILE_APP: '/sys/mobile-app',
    SYS_MANUAL: '/sys/manual',
    SYS_PROXY: '/sys/proxy',
    SYS_BANNER: '/sys/banner',
    SYS_REPORT_FMM: '/sys/report-fmm',
  },
  settings: {
    SETTING_INDEX: '/setting',
    SETTING_CONVERSATION: '/setting/conversation',
    SETTING_USER: '/setting/user',
    SETTING_MANAGE_POSTS: '/setting/manageposts',
    SETTING_MANAGE_PAGE: '/setting/managepage',
    SETTING_META_SM: '/setting/metasmc',
    SETTING_SEND_PURCHASE: '/setting/sendpurchase',
    SETTING_AFFILIATE: '/setting/affiliate',
    SETTING_LOG: '/setting/log',
    SETTING_EXTENSION: '/setting/extension',
    SETTING_DIVISION: '/setting/division',
    SETTING_TAG: '/setting/tag',
    SETTING_QUICK_MSG: '/setting/quickmsg',
    SETTING_ECOM_CUSTOMER_CARE: '/setting/ecomcustomercare',
    SETTING_FORM: '/setting/form',
  },
  business: {
    MANAGE_GOOGLE_SHEET_GENERATE_AUTH_URL: '/store/manage/googlesheetgenerateauthurl',
    MANAGE_GOOGLE_SHEET_LOAD: '/store/manage/googlesheetload',
    BUSINESS_USER_LIST: '/business/user/list',
  }
};

export const URI_PUBLIC = {
  FORM: '/form',
  widgetView: '/livescm',
  CHECKOUT: '/checkout',
}
